import script from "./FileUploads.vue?vue&type=script&setup=true&lang=js"
export * from "./FileUploads.vue?vue&type=script&setup=true&lang=js"

import "./FileUploads.vue?vue&type=style&index=0&id=430c7726&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-430c7726"]])

export default __exports__